<template>
  <div class="home">
    <v-card class="unbound-card">
      <div  class="all-sponsors-card">
        <v-card class="sponsorTabsCard">
          <div class="sponsorMessageCard">
            <span class="sponsorMessage">
              Thank you to all of our DFWVGA sponsors. Our club officers, members, and all participants appreciate
              your sponsorship and contributions. We all thank you!
            </span>
          </div>
          <v-tabs class="sponsorTabs" background-color="#e6f2ea">
            <v-tab class="sponsorTab platinumTab" @click="selectView(1)">Platinum</v-tab>
            <v-tab class="sponsorTab goldTab" @click="selectView(2)">Gold</v-tab>
            <v-tab class="sponsorTab silverTab" @click="selectView(3)">Silver</v-tab>
          </v-tabs>
        </v-card>

        <v-card class="platinumView" v-if="viewSelected === 1">
          <v-card-text class="d-flex align-center justify-center fill-bar-div" ratio="4:3">
            <img class="logo" src="../assets/img/platinum-logo-2.png" alt="" v-if="!$AuthSvc.isSmallMobile()">
            <span class="fill-bar-title">{{$AuthSvc.getYear()}} Platinum Sponsors</span>
          </v-card-text>

          <v-card-text class="d-flex align-center justify-center sponsor-platinum-card"
                       v-for="sponsor in platinumSponsors" :key="sponsor">
            <div id="imageCardSizeId" class="platinum-card-div">
              <img class="platinum-image" :src="'/images/sponsors-ad/'+sponsor.photoName">
              <div class="platinum-card-info">
                <div class="left-info">
                  <span class="label14" >Website: </span>
                  <a class="label12" :href="sponsor.website">{{sponsor.website}}</a>
                  <span style="display:inline-block; width: 20px;" v-if="$AuthSvc.isMobile() && !$AuthSvc.isSmallMobile()"></span>
                  <br>
                  <span class="label14">Phone: </span>
                  <span v-if="$AuthSvc.isDesktop()">
                  {{sponsor.phone}}
                </span>
                  <a :href="'tel:' + sponsor.phone" v-if="!$AuthSvc.isDesktop()">
                    {{sponsor.phone}}
                  </a>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card class="goldView" v-if="viewSelected === 2">
          <v-card-text class="sponsor-card" style="margin-top: 30px;">
            <v-img class="sponsor-img" :src="require(`../assets/img/sponsors/Gold.png`)">
            </v-img>
          </v-card-text>
          <v-card-text class="sponsor-card">
            <div class="gold-card" v-for="sponsor in goldSponsors" :key="sponsor">
              <v-img class="sponsor-img" :src="'/images/sponsors-ad/'+sponsor.photoName">
              </v-img>
            </div>
          </v-card-text>
        </v-card>

        <v-card class="silverView" v-if="viewSelected === 3">
          <v-card-text class="sponsor-card">
            <v-img class="sponsor-img" :src="require(`../assets/img/sponsors/Silver.png`)">
            </v-img>
          </v-card-text>
          <v-card-text class="sponsor-card">
            <div class="silver-card" v-for="sponsor in silverSponsors" :key="sponsor">
              <v-img class="sponsor-img" :src="'/images/sponsors-ad/'+sponsor.photoName">
              </v-img>
            </div>
          </v-card-text>
        </v-card>

      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: "sponsors",
    data: () => ({
      platinumSponsors: [],
      goldSponsors: [],
      silverSponsors: [],
      viewSelected: 1
    }),
    mounted: function() {
      this.loadData();
    },
    methods: {
      loadData() {
        var _this = this;
        _this.$CommandSvc.get(_this, '/public/sponsors',
            function (response) {
                let data = response;
                for( var i=0; i < data.length; i++) {
                    if (data[i].sponsorType === 'Platinum') {
                        _this.platinumSponsors.push(data[i]);
                    }
                    else if (data[i].sponsorType === 'Gold') {
                        _this.goldSponsors.push(data[i]);
                    }
                    else if (data[i].sponsorType === 'Silver') {
                        _this.silverSponsors.push(data[i]);
                    }
                }
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
      },
      getFileName(fileName) {
        return "/images/sponsors-ad/" + fileName;
      },
      getPhone(sponsor) {
        // console.log("BEN " + sponsor.phone);
        return "\"" + sponsor.phone + "\"";
      },
      selectView(viewId) {
        this.viewSelected = viewId;
      }
    }
  }
</script>

<style scoped>
  .v-slide-group__wrapper {
    background-color: #e6f2ea !important;
  }

  .sponsorTab{
    font-weight: bold;
    color: navy;
    background-repeat: repeat;
    background-size: cover;
    margin-right: 5px;
    border-radius: 12px;
    margin: 5px 5px;
  }

  .platinumTab {
    background-image: url("../assets/img/platinum-bg-1.jpeg");
  }

  .goldTab {
    background-image: url("../assets/img/gold-bg-1.jpeg");
  }

  .silverTab {
    background-image: url("../assets/img/silver-bg-2.jpeg");
  }

  .sponsorMessageCard {
    display: block;
    padding: 20px;
  }

  .logo {
    width: 90px;
    padding: 5px;
    display: inline-block;
    float: left;
    margin: 6px 0 6px 30px;
    border-radius: 50%;
  }

  .fill-bar-div {
    display: inline-block;
    width: 100%;
    background-image: url("../assets/img/platinum-bg-1.jpeg");
    background-repeat: repeat;
    background-size: cover;
    border-radius: 7px;
    border: 2px solid navy;
    margin-bottom: 10px;

  }

  .fill-bar-title {
    display: inline-block;
    font-size: 20px;
    font-weight: 900;
    color: mediumblue;
    margin: 40px 10px !important;
  }

  .sponsor-platinum-card {
    display: inline-block;
    width: 100% !important;
  }

  .platinum-card-div {
    display: inline-block;
    width: 100% !important;
    margin-bottom: 10px;
    margin-top: 20px;
  }

  .platinum-card-image-div {
    display: inline-block;
    background-image: url("../assets/img/platinum-frame-2.png");
    background-repeat: no-repeat;
    background-size: contain;
    padding: 12px;
    width: 50% !important;
  }

  .platinum-image {
    display: inline-block;
    width: 100% !important;
    object-fit: fill;
    border-radius: 15px;
    border: 3px solid navy;
  }

  .platinum-card-info {
    display: inline-block;
    width: 100% !important;
  }

  .sponsor-card {
    padding: 0 10px !important;
    background-color: white;
    display: inline-block;
  }

  .sponsor-img {
    display: block;
    border-radius: 5px;
  }

  .platinum-card {
    display: inline-block;
    padding: 10px;
    width: 100%;
    margin-bottom: 20px;
  }

  .gold-card {
    display: inline-block;
    float: left;
    padding: 10px;
    width: 46%;
    height: 140px;
    margin-bottom: 7px;
  }

  .silver-card {
    display: inline-block;
    float: left;
    padding: 10px;
    width: 32%;
    height: 140px;
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    .fill-bar-div {
      height: 100px !important;
    }

    .fill-bar-title {
      float: left;
      font-size: 26px;
    }

    .platinum-card-div {
      display: inline-block;
      width: 100% !important;
    }

    .platinum-image {
      display: inline-block;
      width: 720px !important;
      object-fit: fill;
      border-radius: 15px;
      float: left;
    }

    .platinum-card-info {
      display: inline-block;
      width: 280px !important;
      height: 200px;
      padding: 10px;
      float: left;
    }

    .platinum-card-info > .left-info {
      display: inline-block;
      width: 100%;
      float: left;
    }

    .platinum-card-info > .right-info {
      display: inline-block;
      width: 100%;
      float: left;
    }

    .all-sponsors-card {
      margin: auto;
      width: 1024px;
    }

    .sponsor-card {
      width: 100% !important;
      padding: 0 10px !important;
    }

    .sponsor-img {
      max-width: 100%;
      max-width: 100%;
      margin-bottom: 25px;
    }

    .platinum-card {
      margin-bottom: 40px;
    }

    .gold-card {
      margin-bottom: 40px;
      height: 320px;
    }

    .silver-card {
      margin-bottom: 40px;
      height: 300px;
    }
  }
</style>
